
import Slack from "../../../assets/outline/Slack.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function SlackIcon({ className, dataTestid = "SlackIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <Slack data-testid={dataTestid} className={classes} {...rest} />
  );
}
